/**
 * Cancellations Trend Chart (Highcharts)
 * Column chart showing monthly cancellation counts
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function CancellationsTrendChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Monthly Cancellations' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
        credits: { enabled: false },
      };
    }

    return {
      chart: {
        type: 'column',
        height: 350,
      },
      title: {
        text: 'Monthly Cancellations',
        style: { fontSize: '16px', fontWeight: '600' },
      },
      subtitle: {
        text: 'Count of cancelled reservations by check-in month. ℹ︎ Includes all cancellations regardless of cancellation date.',
        style: { fontSize: '12px', color: '#666' },
      },
      xAxis: {
        categories: data.map(d => d.month),
        title: { text: 'Month' },
      },
      yAxis: {
        title: { text: 'Number of Cancellations' },
        min: 0,
      },
      tooltip: {
        backgroundColor: '#ffffff', // Fully opaque white background
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: {
          color: '#111827', // Dark text for readability
        },
        formatter: function() {
          return '<b>' + this.x + '</b><br/>' +
            'Cancellations: <b>' + this.y + '</b>';
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              // Only show labels for values > 0 to avoid clutter
              if (this.y > 0) {
                return this.y;
              }
              return '';
            },
            style: {
              fontSize: '11px',
              fontWeight: '500',
              textOutline: '1px contrast',
            },
          },
          color: '#ef4444', // Red color for cancellations
        },
      },
      series: [{
        name: 'Cancellations',
        data: data.map(d => d.cancellation_count),
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
